<template lang="pug">
  div
    v-autocomplete(v-model='model' :items='context.users' :loading='isLoading' :search-input.sync='search' clearable text hide-no-data hide-selected item-text='fullName' item-value='id' :label='label' :filter='customFilter' return-object @input='valueChanged($event)')
      template(v-slot:no-data)
        v-list-item
          v-list-item-title
            | Search
            strong Users
      template(v-slot:selection='{ item, selected }')
        v-chip.white--text(:input-value='selected' color='blue-grey')
          v-avatar.blue {{item.fullName.substring(0,2).toUpperCase()}}
          span(v-text='item.fullName')
      template(v-slot:item='{ item }')
        v-list-item-avatar.headline.font-weight-light.white--text(color='indigo') {{ item.fullName.substring(0,2).toUpperCase() }}
        v-list-item-content
          v-list-item-title(v-text='item.fullName')
          v-list-item-subtitle(v-text='item.mobileNumber')

</template>
<script>
export default {
  name: "user-selector",
  props: { label: String, context: Object },
  components: {},
  created() {
    if (this.context.selectedId) {
      this.model = this.context.users.find(u => {
        return u.id === this.context.selectedId;
      });
    }
  },
  data: () => ({
    isLoading: false,
    model: null,
    search: null
  }),
  methods: {
    customFilter(item, queryText) {
      const textOne = item.fullName.toLowerCase();
      const textTwo = item.mobileNumber.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    valueChanged(newUser) {
      this.$emit("change", newUser);
    }
  }
};
</script>